import React from 'react';


const VideoCategoryList = ({ categories }) => {
  return (
    <div className="mt-5">
      {categories.map((category, index) => (
        <div className="mb-5" key={index}>
          <h2>{category.name}</h2>
          <div className="flex overflow-x-scroll">
            {category.videos.map((video, videoIndex) => (
              <div className="min-w-[16rem] mr-2.5 text-center" key={videoIndex}>

                <img 
                  src={`${import.meta.env.VITE_FOTO || ''}/${video.thumbnail}`} 
                  alt={video.title}
                  className="w-[16rem] h-[9rem] object-cover rounded-lg"
                />

                <div className="mt-1.5 text-sm">{video.title}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoCategoryList;
